import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import * as CollectionActions from '../actions/collection.actions';
import * as ProductActions from '../actions/product.actions';
import {LoadingCollection, Product} from '../models/product';
import {createReducer, on} from '@ngrx/store';

/**
 * books kind of work as cache
 */

export interface State extends EntityState<Product> {
    selectedProductId: number | null;
    loadingCollection: LoadingCollection;
    selectedProduct: Product;
}

export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>({
    selectId: (product: Product) => product.id,
    sortComparer: false
});

export const initialState: State = adapter.getInitialState({
    selectedProductId: null,
    loadingCollection: [],
    isLoading: false,
    selectedProduct: null
});

// we can do this here since actions are really simple, no need for reducer map
const loadingReducer = createReducer(
    initialState.loadingCollection,
    on(ProductActions.actionStart, (loadingCollection, {product}) => {
        return {...loadingCollection, [product.id]: true};
    }),
    on(ProductActions.actionSuccess, ProductActions.actionError, ((loadingCollection, {product}) => {
        return {...loadingCollection, [product.id]: false};
    })),
    on(ProductActions.load, (loadingCollection, {productIds}) => {
            return addProductsToLoadingCollection(loadingCollection, productIds, true);
        },
    ),
    on(ProductActions.loadFailure, ProductActions.loadSuccess, (loadingCollection, {productIds}) => {
        return addProductsToLoadingCollection(loadingCollection, productIds, false);
    }),
);

function addProductsToLoadingCollection(loadingCollection: LoadingCollection, productIds: number[], isLoading: boolean) {
    const newLoadingCollection = {...loadingCollection};
    productIds.forEach(id => newLoadingCollection[id] = isLoading);
    return newLoadingCollection;
}

export const reducer = createReducer(
    initialState,
    on(CollectionActions.addSuccess, CollectionActions.loadSuccess, (state, {products}) => {
        return adapter.upsertMany(products, state);
    }),
    on(ProductActions.loadSuccess, (state, action) => {
        return adapter.upsertMany(action.products, {
            ...state,
            loadingCollection: loadingReducer(state.loadingCollection, action)
        });
    }),
    on(ProductActions.select, (state, {id}) => {
        return {...state, selectedProductId: id};
    }),
    on(ProductActions.load,
        ProductActions.loadFailure,
        ProductActions.actionStart,
        ProductActions.actionSuccess,
        ProductActions.actionError, (state, action) => {
            return {...state, loadingCollection: loadingReducer(state.loadingCollection, action)};
        }),
    on(ProductActions.selectProduct, (state, product) => ({...state, selectedProduct: product}))
);


export const getLoadingCollection = (state: State) => state.loadingCollection;
export const getSelectedProduct = (state: State) => state.selectedProduct;